import { Map } from '@powerportalspro/react-maps';

// The accounts and contacts the server registers for maps, near a place: the Near button on the
// map's toolbar finds an address with the map provider's own search, or uses the visitor's location,
// and the map shows only the rows within the distance chosen, nearest first, the circle drawn and the
// map fitted to it. Each row's popup says how far it is. `nearDistances` sets the distances on offer
// and `nearDistance` the one it starts at; the unit switches between miles, the default, and
// kilometers (`nearDistanceUnit`).
//
// The server reads the square around the circle by each table's coordinates, keeps the rows within
// the distance, and returns the nearest — at most NearSearchOptions.MaximumMatches, 500 by default.

// The views the server registers for this map: accounts and contacts, which it opens on, or either alone.
const ACCOUNTS_AND_CONTACTS_VIEW_ID = '4e7b1c92-5a3d-4f08-b6e1-9c2d7a5f3e10';
const ACCOUNTS_VIEW_ID = '4e7b1c92-5a3d-4f08-b6e1-9c2d7a5f3e11';
const CONTACTS_VIEW_ID = '4e7b1c92-5a3d-4f08-b6e1-9c2d7a5f3e12';
const MAP_VIEW_IDS = [ACCOUNTS_AND_CONTACTS_VIEW_ID, ACCOUNTS_VIEW_ID, CONTACTS_VIEW_ID];

const DISTANCES = [10, 25, 50, 100, 250];
const UNITED_STATES = ['US'];
const LOWER_FORTY_EIGHT = { latitude: 39.5, longitude: -98.35 };

export function MapNearbyMainSample() {
  return (
    <Map
      multiTable
      viewIds={MAP_VIEW_IDS}
      defaultViewId={ACCOUNTS_AND_CONTACTS_VIEW_ID}
      allowNearSearch
      nearDistances={DISTANCES}
      nearDistance={50}
      addressSearchCountries={UNITED_STATES}
      center={LOWER_FORTY_EIGHT}
      zoom={4}
      height="520px"
    />
  );
}
